import { render, staticRenderFns } from "./video.vue?vue&type=template&id=18e026d9&scoped=true"
import script from "./video.vue?vue&type=script&lang=ts"
export * from "./video.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e026d9",
  null
  
)

export default component.exports